<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <PaginatedTable 
            v-if="isLoaded" 
            :title="tableTitle" 
            :icon="tableIcon" 
            :columns="columns" 
            :data="finalReviews" 
            @updatePagination="updatePagination"
            ></PaginatedTable>
        </div>
    </div>
</template>
<script>
    import PaginatedTable from '@/components/Tables/PaginatedTable.vue';
    import { getCompletedFinalReviewColumns } from '@/views/FinalReviewView/columns';
    import { finalReviewApi } from '@/api/api';
    import { completedFinalReviewLabel } from '@/views/FinalReviewView/label';

    export default {
        components: {
            PaginatedTable,
        },
        data() {
            return {
                tableTitle: completedFinalReviewLabel.tableTitle,
                tableIcon: "manage_search",
                isLoaded: false,
                finalReviews: {
                    page_info: {
                        page: 1,
                        size: 5,
                        total_elements: 5,
                        total_pages: 1,
                    },
                    elements: [],
                },
                columns: getCompletedFinalReviewColumns({
                    "description": this.toDetail, 
                }),
            }
        },
        methods: {
            /**
             * 상세보기 작업 처리 메소드 
             */
            toDetail(data) {
                this.$router.push(`/final-reviews/detail/${data.idx}`);
            },
            /**
             * 완료된 총평 목록 API 요청 메서드
             */
            fetchCompletedFinalReview(size, page) {
                const params = {
                    is_completed: true,
                    size: size,
                    page: page,
                    sort_by: "idx", 
                    direction: "desc",
                };

                this.isLoaded = false;
                finalReviewApi.getFinalReviews(params).then(response => {
                    if (response && response.status === 200) {
                        this.finalReviews = response.data;
                        this.isLoaded = true;
                    }else {
                        this.isLoaded = true;
                        alert(completedFinalReviewLabel.apiRequestFailMessage);
                    }
                })
            },
            /**
             * Pagination 타입 명세
             * @typedef {Object} Conditions
             * @property {string} page - 페이지
             * @property {string} size - 사이즈
             * @property {string} total_elements - 전체 데이터 수 
             * @property {string} total_pages - 전체 페이지 수
             */

            /** 
             * 페이지네이션 업데이트 메서드
             *  
             * @description: 페이징 정보가 변경되면 하위 컴포넌트에서 정보를 받아 업데이트 및 API 요청
             * @params {Pagination} pagination
             */
            updatePagination(pagination) {
                this.finalReviews.page_info.size = pagination.size;
                this.finalReviews.page_info.page = pagination.page;

                this.fetchCompletedFinalReview(this.finalReviews.page_info.size, this.finalReviews.page_info.page);
            },
        },
        mounted() {
            this.fetchCompletedFinalReview(this.finalReviews.page_info.size, this.finalReviews.page_info.page);
        }
    }
</script>
<style scoped>
.right-button {
    display: flex;
    justify-self: flex-end;
    margin-right: 20px;
    margin-bottom: -15px;
}
</style>